import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import MyTrips from 'components/MyTrips'

class TripsListScene extends Component {
  static propTypes = {
    tripsList: PropTypes.arrayOf(PropTypes.object).isRequired,
    actions: PropTypes.shape({
      viewTripAsList: PropTypes.func.isRequired,
      viewTripAsMap: PropTypes.func.isRequired,
      addTrip: PropTypes.func.isRequired,
      editTrip: PropTypes.func.isRequired,
    }).isRequired,
  }

  render() {
    const {
      actions,
      tripsList,
    } = this.props
    return (
      <div className="TripsListScene">
        <MyTrips
          trips={tripsList}
          actions={actions}
        />
      </div>
    )
  }
}

export default TripsListScene



// WEBPACK FOOTER //
// ./src/components/_sceneManager/Scenes/TripsListScene/component.js